export interface FormState {
    Type: string;
    Classification: string;
    Name: string;
    Cust_Code: string;
    Salutation: string;
    Contact_Name: string;
    Opening_date: string;
    Contact_No: string;
    Landline_No: string;
    Email: string;
    Town: string;
    Birthdate: string;
    Anniversary: string;
    Status: string;
    Potential_Month_Sales: string;
    Qualification: string;
    Rengo: string;
    Marital_Staus: string;
  }

export const INITIALSTATES = {
    Type: '',
    Classification: '',
    Name: '',
    Cust_Code: '',
    Salutation: '',
    Contact_Name: '',
    Contact_Last_Name:'',
    Opening_date: '',
    Contact_No: '',
    Landline_No: '',
    Email: '',
    Town: '',
    Birthdate: '',
    Anniversary: '',
    Status: '',
    Potential_Month_Sales: '',
    Qualification: '',
    Rengo: '',
    Marital_Status: '',
  };



export const FORM_ACTIONS={
    SET_FIELD:'SET_FIELD',
    RESET_FORM:'RESET_FORM',
    SET_FORM_DATA:'SET_FORM_DATA',
}




export const FormReducer = (state:any,action:any)=>{ 
    // console.log("Reducer Action:", action); // 🔍 Logs action type & payload
    switch(action.type){
        case FORM_ACTIONS.SET_FIELD:
            return {...state,[action.field]: action.value}

        
        case FORM_ACTIONS.SET_FORM_DATA:
                return {...state,...action.payload};

        case FORM_ACTIONS.RESET_FORM:
            return INITIALSTATES;

        default:
            return state;
    }
}